import React, { useMemo } from 'react';
import { AgendaComponentInterface, AgendaEntry, SpeakerEntry } from '../../../../../../interfaces/pagebuilder';
import Entry from './Entry';

interface EntryGrouProps {
  entries: AgendaEntry[];
  label: string;
  openSpeaker: (speaker: SpeakerEntry) => void;
  uiComponent: AgendaComponentInterface;
}

const EntryGroup = ({ entries, label, openSpeaker, uiComponent }: EntryGrouProps) => {
  const sortedEntries = useMemo(() => [...entries].sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()), [entries]);

  return (
    <>
      <div className="flex flex-col @md:flex-row mt-4 w-full">
        <span style={{ minWidth: '150px' }}>
          <h2 className="text-2xl mr-4 font-bold mt-2">{label}</h2>
        </span>
        <div className="border-l" />
        <div className="flex flex-col w-full space-y-2 ml-4 @md:space-y-0">
          {sortedEntries.map((entry, index) => (
            <Entry
              withHoverAnimation={uiComponent.enableHoverEffect}
              key={index + entry.title}
              entry={entry}
              openSpeaker={openSpeaker}
              uiComponent={uiComponent}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default EntryGroup;
